export const UNIT_TYPE = {
  'LIVING': {value: 'LIVING', label: 'Wohneinheit', short: 'WE', color: 'rgba(241, 158, 56, 0.8)'},
  'COMMERCIAL_GENERAL': {
    value: 'COMMERCIAL_GENERAL',
    label: 'Geschäftseinheit',
    short: 'GE',
    color: 'rgba(49, 96, 152, 0.8)'
  }
}